import React from 'react'

import Header from '../../components/Header/index'
import Banner from '../../components/Banner/index'
import TextIntro from '../../components/TextIntro/index'
import Benefits from '../../components/Benefits/index'
import Mosaic from '../../components/Mosaic/index'
import Special from '../../components/Special/index'
import Step from '../../components/Step/index'
import Kit from '../../components/Kit/index'
import LinkForm from '../../components/Form/index'
import Testimonials from '../../components/Testimonials/index'
import Questions from '../../components/Questions/index'
import Footer from '../../components/Footer/index'
import MenuAside from '../../components/MenuAside/index'

const Home = () => {
  return (
    <>
      <Header />
      <Banner />
      <TextIntro />
      <Benefits />
      <Mosaic />
      <Special />
      <Step />
      <Kit />
      <LinkForm />
      <Testimonials />
      <Questions />
      <Footer />
      <MenuAside />
    </>
  );
};

export default Home;
